import { BaseAction } from "../../../core/actions/BaseAction";
import { updateRecoilState } from "../../../Orchestrator/Recoils/Events/Recoil";
import { PriceInfo } from "../../../Orchestrator/Types/Types/TrainTypes";


export class PremiumTrainSelectAction extends BaseAction<void, { priceInfo: PriceInfo }> {

    override async run(): Promise<void | null> {
        try {
            const { priceInfo } = this.params!;            
            const offerId: string | null = priceInfo.premium.offerId || null;
            const shuttleOfferId: string | null = priceInfo.shuttle?.offerId || null;
            if (!priceInfo.premium.isSoldOut) {
                updateRecoilState<string | null>("selectedOfferIdAtom", offerId);
                updateRecoilState<string | null>("selectedShuttleOfferIdAtom", shuttleOfferId);
                // setPrivacySeating(false);
                // setPrivacyPremuimSeating(false);
                // updateRecoilState("dateState", startDate);
            }

        } catch (error) {
            console.error("Error in PremiumTrainSelectAction:", error);
        }
    }
}

// Create a singleton instance
export const premiumTrainSelectAction = new PremiumTrainSelectAction(); 